export default "__VITE_ASSET__DBdyaZxD__"